export default __webpack_public_path__ + "static/events-light-517b2d967829db33f6793cee8d2521de.png";